import styled from 'styled-components';
import Table from '../../CommonComponents/Table';
import { StyledButton as Button } from '../../CommonComponents/Button';
import LoadingMask from '../../CommonComponents/LoadingMask';
import Dropdown from '../../CommonComponents/Dropdown';

export const TableCell = styled(Table.Cell)`
  padding: 20px 1em;
`;

export const RightAlignedTableCell = styled(TableCell)`
  text-align: right;
`;

export const TransactionsTable = styled(Table)`
  ${({ isFilterOpen }) =>
    isFilterOpen
      ? `
      &:after {
        background-color: rgba(0, 0, 0, 0.2);
        pointer-events: auto;
      }
    `
      : `
      &:after {
        background-color: rgba(0, 0, 0, 0.0);
      }
    `};
  position: relative;
  &:after {
    transition: background-color 0.4s ease;
    pointer-events: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: block;
    content: '';
  }
  width: 100%;
`;

export const TransactionDescriptionCell = styled(TableCell)`
  position: relative;
  width: 300px;
`;

export const HoverableTableRow = styled(Table.Row)`
  &:hover {
    background-color: #ecf2f8;
    cursor: pointer;
  }
`;

export const CategoryDropdown = styled(Dropdown)`
  display: block;
`;

export const TransactionDescriptionContent = styled.div`
  display: inline-block;
  position: relative;
  width: 280px;
  white-space: pre-wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: transparent;
  transition: background 0.3s ease;
`;

export const EditTransactionCell = styled(TableCell)`
  text-align: right;
`;

export const AccountNameCell = styled(TableCell)`
  @media (min-width: 1200px) and (max-width: 1255px), (max-width: 1010px) {
    display: none;
  }
`;

export const TransactionCategoryTriggerButton = styled(Button).attrs({
  appearance: 'link',
  padding: 'none',
  appendIcon: 'fa fa-angle-down',
})`
  font-weight: normal;
  font-size: 1rem;
`;

export const EditTransactionButton = styled(Button).attrs({
  appearance: 'link',
  padding: 'none',
})`
  font-size: 1.5em;
`;

export const ShowMoreCell = styled(TableCell).attrs({
  colSpan: 6,
})`
  padding: 0;
  background-color: #f6f6f6;
  border-top: 1px solid #d9d7d7;
`;

export const ShowMoreButton = styled(Button)`
  width: 100%;
  padding: 0.9em 0;
  line-height: 1.2;
  font-weight: normal;
  font-size: 16px;
`;

export const TableHeaderButton = styled(Button.Link)`
  color: rgba(70, 67, 71, 0.78);
  font-size: 0.875rem;
  text-transform: uppercase;
`;

export const LoadingRow = styled(LoadingMask).attrs({
  isDark: true,
})`
  border-radius: 5px;
  height: 27px;
`;
